import { render, staticRenderFns } from "./BlackListContacts.vue?vue&type=template&id=7ca2df4d&"
import script from "./BlackListContacts.vue?vue&type=script&lang=ts&"
export * from "./BlackListContacts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports